<template>
  <div>
    <div class="dropdown">
        <button id="drop-btn" @click="clickDropdown()">
            {{orderBy === 'price_asc' ? lbl.searchList.sort_lowPrice : orderBy ===  'price_desc' ? lbl.searchList.sort_highPrice : orderBy === 'score' ? lbl.searchList.sort_recommen : ''}}
            <img class="ml-5" src="@/assets/icon/ic-arrow-down.svg" />
        </button>
        <div v-if="showList" class="dropdown-content">
            <div class="item" @click="clickOrderBy('price_asc')">
                <template v-if="orderBy == 'price_asc'">
                    <div class="active">
                        {{ lbl.searchList.sort_lowPrice }}
                    </div>
                    <img src="@/assets/icon/ic-select.svg" />
                </template>
                <template v-else>
                    <span>
                        {{ lbl.searchList.sort_lowPrice }}
                    </span>
                </template>
            </div>
            <div class="item" @click="clickOrderBy('price_desc')">
                <template v-if="orderBy == 'price_desc'">
                    <div class="active">
                        {{ lbl.searchList.sort_highPrice }}
                    </div>
                    <img src="@/assets/icon/ic-select.svg" />
                </template>
                <template v-else>
                    <span>
                        {{ lbl.searchList.sort_highPrice }}
                    </span>
                </template>
            </div>
            <div class="item" @click="clickOrderBy('score')">
                <template v-if="orderBy == 'score'">
                    <div class="active">
                        {{ lbl.searchList.sort_recommen }}
                    </div>
                    <img src="@/assets/icon/ic-select.svg" />
                </template>
                <template v-else>
                    <span>
                        {{ lbl.searchList.sort_recommen }}
                    </span>
                </template>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'ButtonDropdown',
    mixins:[ModalMixin,LocaleMixin],
    data: function() {
        return {
            showList: false,
            orderBy: 'price_asc'
        }
    },
    created: function() {
        this.clickOrderBy(this.orderBy)
    },
    computed: {
    },
    methods: {
        clickDropdown: function() {
            this.showList = !this.showList
        },
        clickOrderBy: function(keyword) {
            this.orderBy = keyword
            this.showList = false
            this.$emit('orderBy', keyword)
        },
        setValue: function(val) {
            this.orderBy = val
        }
    },
}
</script>

<style scoped lang="scss">
@import "../../../../style/base/base.scss";
@import "./ButtonDropdown.scss";

#drop-btn {
    max-width: 200px;
    background-color: #ffffff;
    color: $a-black-333333;
    padding: 6px;
    font-size: 16px;
    border: none;
    display: flex;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    justify-content: space-between;
}
</style>
